<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeDomiciliationBancaire.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsDomiciliationBancaire.maj) }"
               @click="$router.push({ name: 'm.parametrage.domiciliation_bancaire-add' })">
              {{ $t('listeDomiciliationBancaire.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('listeDomiciliationBancaire.actions.search')"
                     type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" ref="tableDomiciliationBancaire"
                    @loaded="finLoading" @loading="debutLoading">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableDomiciliationBancaire.setLimit($event)"/>
      </template>
      <div slot="actif" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.actif" type="is-default"
                    class="pointer-events-none">
        </b-checkbox>
      </div>
      <div slot="libelle" slot-scope="props">
        <router-link :to="{
        name: 'c.parametrage.domiciliation_bancaire', params: { id: props.row.id }}"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(permsDomiciliationBancaire.lecture)}"
                     class="lien">
          {{ props.row.libelle }}
        </router-link>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="$router.push({name: 'm.parametrage.domiciliation_bancaire-edit',
        params: { id: props.row.id }})">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsDomiciliationBancaire.maj)
              }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="archivage" class="has-text-centered">
        <a @click="inProgress()">
          <b-icon icon="archive" type="is-default"
                  :class="{
                'text-access-no-permission' :
                !checkPermissions(permsDomiciliationBancaire.supprimer)
                }"
          >
          </b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permsDomiciliationBancaire.supprimer) ?
          inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permsDomiciliationBancaire.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
    </v-server-table>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import { DOMICILIATIONS_BANCAIRES } from '@/configuration/general/permissionsParametrageConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import TableItemsInView from '@/components/general/TableItemsInView';

const permissions = createNamespacedHelpers('permissions');
const DomiciliationBancaires = createNamespacedHelpers('domiciliationBancaire');
const societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: {},
      permsDomiciliationBancaire: DOMICILIATIONS_BANCAIRES,
      unsubscribeValue: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeDomiciliationBancaire.title'), route: { name: '' }, isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...DomiciliationBancaires.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeDomiciliationBancaire.tab.libelle'),
          titulaire: this.$t('listeDomiciliationBancaire.tab.titulaire'),
          numCpta: this.$t('listeDomiciliationBancaire.tab.compteComptable'),
          actif: this.$t('listeDomiciliationBancaire.tab.actif'),
          codeJournal: this.$t('listeDomiciliationBancaire.tab.codeJournal'),
          edit: '',
          delete: '',
          archivage: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
          };
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadDomiciliationBancaire(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          actif: 'colonneAction',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archivage: 'colonneSelected',
        },
        sortable: ['libelle', 'titulaire', 'numCpta', 'codeJournal', 'actif'],
      };
    },
    columns() {
      return ['libelle', 'titulaire', 'numCpta', 'codeJournal', 'actif', 'edit', 'archivage', 'delete'];
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...DomiciliationBancaires.mapActions({
      actionsLoadDomiciliationBancaire: 'loadDomiciliationBancaire',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    recherche() {
      this.$refs.tableDomiciliationBancaire.refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs.tableDomiciliationBancaire.setPage(1);
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageParametrage.domiciliationBancaire.liste'));
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>

<style scoped>

</style>
